import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ko from '../locales/ko.json';
import en from '../locales/en.json';
import my from '../locales/my.json';

export const ADMIN_LANG_STORAGE_KEY = 'kairos-admin-language';

const resources = {
  ko: { translation: ko },
  en: { translation: en },
  my: { translation: my },
};

const saved =
  typeof localStorage !== 'undefined'
    ? localStorage.getItem(ADMIN_LANG_STORAGE_KEY) ||
      localStorage.getItem('kairos-language')
    : null;

i18n.use(initReactI18next).init({
  resources,
  lng: saved || 'ko',
  fallbackLng: 'ko',
  interpolation: { escapeValue: false },
});

export const changeLanguage = async (lng) => {
  await i18n.changeLanguage(lng);
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(ADMIN_LANG_STORAGE_KEY, lng);
    localStorage.setItem('kairos-language', lng);
  }
};

export const getCurrentLanguage = () => i18n.language?.split('-')[0] || 'ko';

export default i18n;
